import type { GameKindAdapter } from "./shared/adapter";
import type { GameKind } from "./spec-types";
import { cardTurnAdapter } from "./card-turn";
import { endlessRunnerAdapter } from "./endless-runner";
import { gridStrategyAdapter } from "./grid-strategy";
import { paddleDuelAdapter } from "./paddle-duel";
import { quizAdapter } from "./quiz";
import { sourceGameAdapter } from "./source-game";
import { targetRangeAdapter } from "./target-range";
import { topDownCollectAdapter } from "./top-down-collect";

/**
 * Legacy adapters stay registered so existing immutable projects continue to
 * compile. New natural-language generation enters through source-game.
 */
export const gameKindRegistry: Record<GameKind, GameKindAdapter> = {
  "top-down-collect": topDownCollectAdapter,
  "paddle-duel": paddleDuelAdapter,
  "target-range": targetRangeAdapter,
  "quiz": quizAdapter,
  "endless-runner": endlessRunnerAdapter,
  "grid-strategy": gridStrategyAdapter,
  "card-turn": cardTurnAdapter,
  "source-game": sourceGameAdapter,
};

export const gameKinds: readonly GameKind[] = Object.keys(gameKindRegistry) as GameKind[];
